import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from "react";
import { LoadingView } from "../components";
import { LoadingContextType } from "./data";

const LoadingContext = createContext<LoadingContextType>({
  isLoading: false,
  setIsLoading: () => {},
});

type LoadingContextProviderType = PropsWithChildren & {};

export const LoadingContextProvider = ({
  children,
}: LoadingContextProviderType) => {
  const [isLoading, setIsLoading] = useState(false);
  const loading = useMemo(() => {
    return (
      <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
        {children}
        {isLoading && <LoadingView />}
      </LoadingContext.Provider>
    );
  }, [isLoading]);

  return loading;
};

export const useLoading = () => {
  const LoadingValue = useContext(LoadingContext);
  return LoadingValue;
};
